import service from '@/utils/request'; // CreateBairunCountryPrice 添加油品的国家指导价
// @Tags Station
// @Summary 添加油品的国家指导价
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunCountryPriceRequest true "添加油品的国家指导价"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /priceMange/countryPrice/create [post]

export var createBairunCountryPrice = function createBairunCountryPrice(data) {
  return service({
    url: '/priceManage/countryPrice/create',
    method: 'post',
    data: data
  });
}; // DeleteBairunCountryPrice 删除油品的国家指导价
// @Tags Station
// @Summary 删除油品的国家指导价
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunCountryPriceRequest true "删除油品的国家指导价"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"删除成功"}"
// @Router /priceMange/countryPrice/delete [delete]

export var deleteBairunCountryPrice = function deleteBairunCountryPrice(data) {
  return service({
    url: '/priceManage/countryPrice/delete',
    method: 'post',
    data: data
  });
}; // DeleteBairunCountryPriceByIds 批量删除油品的国家指导价
// @Tags Station
// @Summary 批量删除油品的国家指导价
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.IdsReq true "批量删除油品的国家指导价"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"批量删除成功"}"
// @Router /priceMange/countryPrice/deleteByIds [delete]

export var deleteBairunCountryPriceByIds = function deleteBairunCountryPriceByIds(data) {
  return service({
    url: '/priceManage/countryPrice/deleteByIds',
    method: 'post',
    data: data
  });
}; // UpdateBairunCountryPrice 更新油品的国家指导价
// @Tags Station
// @Summary 更新油品的国家指导价
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunCountryPriceRequest true "更新油品的国家指导价"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"更新成功"}"
// @Router /priceMange/countryPrice/update [put]

export var updateBairunCountryPrice = function updateBairunCountryPrice(data) {
  return service({
    url: '/priceManage/countryPrice/update',
    method: 'put',
    data: data
  });
}; // FindBairunCountryPrice 查找油品的国家指导价
// @Tags Station
// @Summary 查找油品的国家指导价
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunCountryPriceRequest true "查找油品的国家指导价"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"查询成功"}"
// @Router /priceMange/countryPrice/find [get]

export var findBairunCountryPrice = function findBairunCountryPrice(params) {
  return service({
    url: '/priceManage/countryPrice/find',
    method: 'get',
    params: params
  });
}; // GetBairunCountryPriceList 分页获取油品的国家指导价的数据
// @Tags Station
// @Summary 分页获取油品的国家指导价的数据
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body bairunRequest.BairunCountryPriceSearch true "分页获取油品的国家指导价的数据"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /priceMange/countryPrice/getList [get]

export var getBairunCountryPriceList = function getBairunCountryPriceList(params) {
  return service({
    url: '/priceManage/countryPrice/getList',
    method: 'get',
    params: params
  });
};